import React from 'react'
import { BadgeSize } from '@chegg-wt/core/components/Modals/DiscountModal/SaleBadge/SaleBadge'
import { DiscountBadgeText, SaleBadge } from './styled'

export const DiscountSaleBadge: React.FC<{ discountPercentage: number }> = ({
  discountPercentage,
}) => {
  return (
    <SaleBadge className="discountSaleBadge" size={BadgeSize.XSmall}>
      <DiscountBadgeText>{discountPercentage}% Off</DiscountBadgeText>
    </SaleBadge>
  )
}
